import { apiFetchData, apiPostData, getAdriaticLang } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/apiService';

const lang = getAdriaticLang();
const popupDataPath = 'newsletter-popup/';
const subscribePath = 'newsletter/subscribe-to';

const getNewsletterPopupData = (ssrLang) => apiFetchData(popupDataPath, null, ssrLang ?? lang);
const subscribeToNewsletter = (formData) => apiPostData(subscribePath, {
    twoLetterISOLanguageCode: lang,
    languageCode: formData.languageCode ?? lang,
    ...formData,
});

export { getNewsletterPopupData, subscribeToNewsletter };
